"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx8 = _interopRequireDefault(require("clsx"));
var _context = _interopRequireDefault(require("../Theme/context"));
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["classNames", "Component", "ComponentProps", "long", "ui", "blackAndWhite", "viewBox", "classes", "effect", "autoStopTime", "animationStateInitially", "autoStopInitially"];
var defaultStyle = require("./../empty_css.js")["default"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useContext = (0, _react.useContext)(_context["default"]),
    _useContext$additiona = _useContext.additionalStyles,
    additionalStyles = _useContext$additiona === void 0 ? {} : _useContext$additiona,
    useStyle = _useContext.useStyle;
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? (additionalStyles === null || additionalStyles === void 0 ? void 0 : additionalStyles.logo) || defaultStyle : _props$classNames,
    _props$Component = props.Component,
    Component = _props$Component === void 0 ? _Button["default"] : _props$Component,
    _props$ComponentProps = props.ComponentProps,
    ComponentProps = _props$ComponentProps === void 0 ? {} : _props$ComponentProps,
    _props$long = props["long"],
    _long = _props$long === void 0 ? false : _props$long,
    _props$ui = props.ui,
    ui = _props$ui === void 0 ? false : _props$ui,
    _props$blackAndWhite = props.blackAndWhite,
    blackAndWhite = _props$blackAndWhite === void 0 ? false : _props$blackAndWhite,
    _props$viewBox = props.viewBox,
    viewBox = _props$viewBox === void 0 ? ui ? '0 0 804 337' : _long ? '0 0 952 337' : '0 0 355 337' : _props$viewBox,
    _props$classes = props.classes,
    classes = _props$classes === void 0 ? {} : _props$classes,
    effect = props.effect,
    _props$autoStopTime = props.autoStopTime,
    autoStopTime = _props$autoStopTime === void 0 ? 6000 : _props$autoStopTime,
    animationStateInitially = props.animationStateInitially,
    _props$autoStopInitia = props.autoStopInitially,
    autoStopInitially = _props$autoStopInitia === void 0 ? false : _props$autoStopInitia,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  if (classNames !== (additionalStyles === null || additionalStyles === void 0 ? void 0 : additionalStyles.logo)) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  var container = (0, _react.useRef)();
  var icon = (0, _react.useRef)();
  var animationState = (0, _react.useRef)(typeof animationStateInitially === 'number' ? animationStateInitially : -1);
  var blackAndWhiteState = (0, _react.useRef)(blackAndWhite);
  function setBlackAndWhite(value) {
    if (blackAndWhiteState.current !== value) {
      blackAndWhiteState.current = value;
      if (icon.current) {
        icon.current.setAttribute('class', (0, _clsx8["default"])(classes.icon, classNames.icon, (0, _defineProperty2["default"])({}, classNames.blackAndWhite, blackAndWhiteState.current)));
      }
    }
  }
  var runAnimation = animationState.current;
  function _setRunAnimation(v) {
    animationState.current = v;
    runAnimation = animationState.current;
    if (container.actions) {
      container.actions.setClassName((0, _clsx8["default"])((0, _defineProperty2["default"])({}, classNames.runAnimation, runAnimation >= 0), (0, _defineProperty2["default"])({}, classNames.stopping, runAnimation === 0)));
    }
  }
  var timer = (0, _react.useRef)(0);
  function setRunAnimation(v) {
    var runAnimation = animationState.current;
    if (v !== runAnimation) {
      _setRunAnimation(v);
      if (v >= 0) {
        autoStop();
      }
    }
  }
  function autoStop() {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    if (autoStopTime) {
      timer.current = setTimeout(function () {
        clearTimeout(timer.current);
        var runAnimation = animationState.current;
        if (runAnimation >= 0) {
          setRunAnimation(-1);
        }
      }, autoStopTime);
    }
  }
  (0, _react.useEffect)(function () {
    if (autoStopInitially) {
      autoStop();
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        actions: {
          setRunAnimation: setRunAnimation,
          setBlackAndWhite: setBlackAndWhite
        }
      });
    }
    return function () {
      if (effect) {
        effect({
          actions: {
            setRunAnimation: function setRunAnimation() {},
            setBlackAndWhite: function setBlackAndWhite() {}
          }
        });
      }
    };
  });
  var _ComponentProps$href = ComponentProps.href,
    href = _ComponentProps$href === void 0 ? '' : _ComponentProps$href,
    _ComponentProps$onCli = ComponentProps.onClick,
    onClick = _ComponentProps$onCli === void 0 ? null : _ComponentProps$onCli;
  return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({
    Component: !(href || onClick) ? 'span' : 'a'
  }, ComponentProps, {
    effect: function effect(_ref) {
      var actions = _ref.actions;
      container.actions = actions;
    },
    defaultClassName: (0, _clsx8["default"])(classNames.logo, ComponentProps.className, classes.root, (0, _defineProperty2["default"])({}, classNames.disablePointerEvents, !(href || onClick))),
    className: (0, _clsx8["default"])((0, _defineProperty2["default"])({}, classNames.runAnimation, runAnimation >= 0), (0, _defineProperty2["default"])({}, classNames.stopping, runAnimation === 0)),
    ref: ref,
    variant: 'text',
    size: 'none',
    ButtonBaseContentComponent: function ButtonBaseContentComponent() {
      return /*#__PURE__*/_react["default"].createElement("svg", Object.assign({
        xmlns: 'http://www.w3.org/2000/svg'
      }, rest, {
        viewBox: viewBox,
        className: (0, _clsx8["default"])(classNames.svg, rest.className, (0, _defineProperty2["default"])({}, classNames.blackAndWhite, blackAndWhiteState.current))
      }), /*#__PURE__*/_react["default"].createElement("g", null, ui ? /*#__PURE__*/_react["default"].createElement("g", {
        className: (0, _clsx8["default"])(classNames.ui, classes.ui)
      }, /*#__PURE__*/_react["default"].createElement("g", {
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "27.5",
        y: "43.59",
        width: "29.39",
        height: "250.42",
        style: {
          fill: '#f63'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "177.23",
        y: "44.99",
        width: "29.39",
        height: "250.42",
        style: {
          fill: '#f63'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "322.77",
        y: "44.99",
        width: "29.39",
        height: "250.42",
        style: {
          fill: '#f63'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "473.9",
        y: "46.39",
        width: "29.39",
        height: "250.42",
        style: {
          fill: '#f63'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "622.23",
        y: "43.59",
        width: "29.39",
        height: "250.42",
        style: {
          fill: '#f63'
        }
      })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "31",
        width: "92.36",
        height: "275.56",
        style: {
          fill: '#6c9'
        }
      }), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "381.54",
        y: "31",
        width: "92.36",
        height: "275.56",
        style: {
          fill: '#6c9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "532.67",
        y: "31",
        width: "92.36",
        height: "275.56",
        style: {
          fill: '#6c9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "381.54",
        y: "252.04",
        width: "243.49",
        height: "55.96",
        style: {
          fill: '#6c9'
        }
      })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "31",
        width: "92.36",
        height: "275.56",
        style: {
          fill: '#6c9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "31",
        width: "92.36",
        height: "275.56",
        style: {
          fill: '#6c9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "113.54",
        width: "243.49",
        height: "55.96",
        style: {
          fill: '#6c9'
        }
      }))), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "55.49",
        y: "31",
        width: "29.39",
        height: "277",
        style: {
          fill: '#c9f'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "206.62",
        y: "31",
        width: "29.39",
        height: "277",
        style: {
          fill: '#c9f'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "503.29",
        y: "31",
        width: "29.39",
        height: "277",
        style: {
          fill: '#c9f'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "352.16",
        y: "31",
        width: "29.39",
        height: "277",
        style: {
          fill: '#c9f'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "651.62",
        y: "31",
        width: "29.39",
        height: "277",
        style: {
          fill: '#c9f'
        }
      })), /*#__PURE__*/_react["default"].createElement("g", {
        className: classNames.decoration
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "169.5",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "224.41",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "280.02",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "114.15",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "169.5",
        width: "92.36",
        height: "27.98",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "280.02",
        width: "91.99",
        height: "27.98",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "58.19",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "381.54",
        y: "169.5",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "381.54",
        y: "224.41",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "381.54",
        y: "280.02",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "381.54",
        y: "58.19",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "381.54",
        y: "114.15",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "532.67",
        y: "169.5",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "532.67",
        y: "224.41",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "532.67",
        y: "280.02",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "532.67",
        y: "58.19",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "532.67",
        y: "114.15",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "381.54",
        y: "280.02",
        width: "243.49",
        height: "27.98",
        style: {
          fill: '#ff9'
        }
      })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "169.5",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "224.41",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "280.02",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "58.19",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "114.15",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "169.5",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "224.41",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "280.02",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "58.19",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "114.15",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "113.54",
        width: "243.49",
        height: "27.98",
        style: {
          fill: '#ff9'
        }
      }))))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _long ? /*#__PURE__*/_react["default"].createElement("g", {
        className: (0, _clsx8["default"])(classNames["long"], classes["long"])
      }, /*#__PURE__*/_react["default"].createElement("g", {
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "27.5",
        y: "42.59",
        width: "29.39",
        height: "250.42",
        style: {
          fill: '#f63'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "177.23",
        y: "43.99",
        width: "29.39",
        height: "250.42",
        style: {
          fill: '#f63'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "322.77",
        y: "43.99",
        width: "29.39",
        height: "250.42",
        style: {
          fill: '#f63'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "473.9",
        y: "45.39",
        width: "29.39",
        height: "250.42",
        style: {
          fill: '#f63'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "622.23",
        y: "42.59",
        width: "29.39",
        height: "250.42",
        style: {
          fill: '#f63'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "773.37",
        y: "43.99",
        width: "29.39",
        height: "250.42",
        style: {
          fill: '#f63'
        }
      })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "30",
        width: "92.36",
        height: "275.56",
        style: {
          fill: '#6c9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "854.53",
        y: "123.78",
        width: "69.97",
        height: "181.78",
        style: {
          fill: '#6c9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "832.14",
        y: "30",
        width: "46.18",
        height: "154.37",
        style: {
          fill: '#6c9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "746.78",
        y: "140.52",
        width: "176.32",
        height: "55.96",
        style: {
          fill: '#6c9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "251.04",
        width: "243.49",
        height: "55.96",
        style: {
          fill: '#6c9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "30",
        width: "197.31",
        height: "54.56",
        style: {
          fill: '#6c9'
        }
      })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "381.54",
        y: "30",
        width: "92.36",
        height: "275.56",
        style: {
          fill: '#6c9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "532.67",
        y: "30",
        width: "92.36",
        height: "275.56",
        style: {
          fill: '#6c9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "381.54",
        y: "251.04",
        width: "243.49",
        height: "55.96",
        style: {
          fill: '#6c9'
        }
      })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "30",
        width: "92.36",
        height: "275.56",
        style: {
          fill: '#6c9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "30",
        width: "92.36",
        height: "275.56",
        style: {
          fill: '#6c9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "112.54",
        width: "243.49",
        height: "55.96",
        style: {
          fill: '#6c9'
        }
      }))), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "55.49",
        y: "30",
        width: "29.39",
        height: "277",
        style: {
          fill: '#c9f'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "206.62",
        y: "30",
        width: "29.39",
        height: "277",
        style: {
          fill: '#c9f'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "503.29",
        y: "30",
        width: "29.39",
        height: "277",
        style: {
          fill: '#c9f'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "352.16",
        y: "30",
        width: "29.39",
        height: "277",
        style: {
          fill: '#c9f'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "651.62",
        y: "30",
        width: "29.39",
        height: "277",
        style: {
          fill: '#c9f'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "802.75",
        y: "30",
        width: "29.39",
        height: "138.5",
        style: {
          fill: '#c9f'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "825.14",
        y: "168.5",
        width: "29.39",
        height: "138.5",
        style: {
          fill: '#c9f'
        }
      })), /*#__PURE__*/_react["default"].createElement("g", {
        className: classNames.decoration
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "168.5",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "223.41",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "279.02",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "57.19",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "113.15",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "168.5",
        width: "243.49",
        height: "27.98",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "854.53",
        y: "223.06",
        width: "69.97",
        height: "27.98",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "832.14",
        y: "279.02",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "56.58",
        width: "197.31",
        height: "27.98",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "832.14",
        y: "113.15",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "681.01",
        y: "279.02",
        width: "243.49",
        height: "27.98",
        style: {
          fill: '#ff9'
        }
      })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "381.54",
        y: "168.5",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "381.54",
        y: "223.41",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "381.54",
        y: "279.02",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "381.54",
        y: "57.19",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "381.54",
        y: "113.15",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "532.67",
        y: "168.5",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "532.67",
        y: "223.41",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "532.67",
        y: "279.02",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "532.67",
        y: "57.19",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "532.67",
        y: "113.15",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "381.54",
        y: "279.02",
        width: "243.49",
        height: "27.98",
        style: {
          fill: '#ff9'
        }
      })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "168.5",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "223.41",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "279.02",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "57.19",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "113.15",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "168.5",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "223.41",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "279.02",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "57.19",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "113.15",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "112.54",
        width: "243.49",
        height: "27.98",
        style: {
          fill: '#ff9'
        }
      }))))) : /*#__PURE__*/_react["default"].createElement("g", {
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "27.5",
        y: "42.59",
        width: "29.39",
        height: "250.42",
        style: {
          fill: '#f63'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "177.23",
        y: "43.99",
        width: "29.39",
        height: "250.42",
        style: {
          fill: '#f63'
        }
      })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "30",
        width: "92.36",
        height: "275.56",
        style: {
          fill: '#6c9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "30",
        width: "92.36",
        height: "275.56",
        style: {
          fill: '#6c9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "112.54",
        width: "243.49",
        height: "55.96",
        style: {
          fill: '#6c9'
        }
      })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "55.49",
        y: "30",
        width: "29.39",
        height: "277",
        style: {
          fill: '#c9f'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "206.62",
        y: "30",
        width: "29.39",
        height: "277",
        style: {
          fill: '#c9f'
        }
      })), /*#__PURE__*/_react["default"].createElement("g", {
        className: classNames.decoration
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "168.5",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "223.41",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "279.02",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "57.19",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "113.15",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "168.5",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "223.41",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "279.02",
        width: "92.36",
        height: "27.67",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "57.19",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "236.01",
        y: "113.15",
        width: "92.36",
        height: "27.72",
        style: {
          fill: '#ff9'
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "84.87",
        y: "112.54",
        width: "243.49",
        height: "27.98",
        style: {
          fill: '#ff9'
        }
      }))))));
    }
  }));
});